import { render, staticRenderFns } from "./Providers.vue?vue&type=template&id=78f8dca9&"
import script from "./Providers.vue?vue&type=script&lang=js&"
export * from "./Providers.vue?vue&type=script&lang=js&"
import style0 from "./Providers.vue?vue&type=style&index=0&id=78f8dca9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports